import { TokenResponse } from '@types';

export enum StorageKeys {
  ACCESS_TOKEN = 'token',
  REFRESH_TOKEN = 'refresh_token'
}

const getLocalStorageItem = (key: string) => {
  const item = localStorage.getItem(key);
  try {
    return JSON.parse(item || '');
  } catch {
    return item;
  }
};

const setLocalStorageItem = (key: string, value: unknown) => {
  localStorage.setItem(
    key,
    typeof value === 'object' ? JSON.stringify(value) : `${value}`
  );
};

const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};

const clearAllLocalStorageItems = () => {
  localStorage.clear();
};

const setMultipleLocalStorageItems = (
  dataItems: Array<{ key: string; value: string }>
) => {
  dataItems.forEach((item) => {
    setLocalStorageItem(item.key, item.value);
  });
};

const setTokensInStorage = ({ access_token, refresh_token }: TokenResponse) => {
  setMultipleLocalStorageItems([
    { key: StorageKeys.ACCESS_TOKEN, value: access_token },
    { key: StorageKeys.REFRESH_TOKEN, value: refresh_token }
  ]);
};

export {
  clearAllLocalStorageItems,
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
  setTokensInStorage,
  setMultipleLocalStorageItems
};
